// extracted by mini-css-extract-plugin
export var icon = "_6v-1";
export var subtext = "_6v-0";